import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
    withCredentials: true,
});

api.interceptors.response.use(
    response => response,
    async (error) => {
        if (window.location.pathname !== '/login') {
            const originalRequest = error.config;

            if (
                error.response?.status === 401 &&
                !originalRequest._retry &&
                !originalRequest.url.includes('/auth/refresh')
            ) {
                originalRequest._retry = true;

                try {
                    await api.post('/auth/refresh');
                    return api(originalRequest);
                } catch (refreshError) {
                    console.error('Refresh token failed', refreshError);

                    window.location.href = '/login';
                }
            }
        }

        return Promise.reject(error);
    }
);


export default api;
